import { PayPalNVP } from 'src/pages/paypalnvp/paypal-nvp';

import { ChangeDetectorRef, Component, HostListener, NgZone } from '@angular/core';
import { PlatformLocation, CurrencyPipe } from '@angular/common'
import { DomSanitizer } from '@angular/platform-browser';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';


import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { OrderProviderExtender } from '../../providers/order/order-extender';
import { TouchcrApiOrderformProvider } from '../../providers/touchcr-api-orderform/touchcr-api-orderform';
import { CartProvider } from '../../providers/cart/cart';
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { TouchcrApiLeadProvider } from '../../providers/touchcr-api-lead/touchcr-api-lead';
import { TouchcrApiCouponProvider } from '../../providers/touchcr-api-coupon/touchcr-api-coupon';
import { OrderDetailsProvider } from '../../providers/order-details/order-details';
import { TouchcrApiShippingProvider } from '../../providers/TouchcrApiShippingProvider';
import { CalculateProvider } from '../../providers/calculate/calculate';
import { UrlsProvider } from 'src/app/providers/urls';
import { OrderProvider } from 'src/app/providers/order/order';
import { GeneralProvider } from 'src/app/providers/general';
import { LoggingProvider } from 'src/app/providers/logging';
import { SpinnerProvider } from '../../providers/spinner/spinner';
import { TouchcrApiGeneralExtenderProvider } from '../../providers/touchcr-api-general/touchcr-api-general-extender';
import { TouchcrApiOrderExtenderProvider } from '../../providers/touchcr-api-order/touchcr-api-order-extender';
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { PaypalPaymentExtenderProvider } from '../../providers/paypal/paypal-extender';
import { StateProvider } from 'src/app/providers/state';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';
import { Country } from '../../models/country';
import { CHECKOUT_LABEL, PAYMENT_LABEL, SHIPPING_LABEL } from 'src/constants/constants';
import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { CheckoutCommon } from '../_brand-pages-base/base-controllers/checkout/checkout-common';
import {
  UPGRADE_COOKIE_NAME,
  UpgradeService,
} from './upgrade.service';

export {
  UPGRADE_COOKIE_NAME,
  type UpgradeCookie,
} from './upgrade.service';

/** Mapped product summary derived from currentFunnel.product.description */
export interface ProductSummaryMap {
  filterLabel: string;
  filterBadge: string;
  unitCount: number;
  unitLabel: string;
  hasSubscriptionInDescription: boolean;
  subscriptionFilterPrice: number;
}

@Component({
  selector: 'checkout-common-tc',
  templateUrl: './checkout-commonTC.html',
  styleUrls: ['./checkout-commonTC.scss']
})
export class CheckoutCommonTC extends CheckoutCommon {
  public override isSelectedCB2: boolean = true;

  /** Toggle to select the upgrade */
  upgradeSelected: boolean = false;
  /** From cookie `upgradedQuantity` — total units count for the upgrade. */
  upgradedQuantity: number = 0;
  /** From cookie `selectedQuantity` — units already chosen on the offer selector (default 1). */
  selectedQuantity: number = 1;
  /** From cookie `upgradeSavings` — calculated as difference between savings of the upgrade and the original price; null if omitted. */
  upgradeSavings: number | null = null;
  /** From cookie `uom` — label copy, e.g. "boxes" / "units" */
  uom: string = 'boxes';
  /** One-shot "success" banner after /fst/ handoff (driven by session, see UpgradeService). */
  private upgradedViewActive: boolean = false;

  /** When the OS page set `hideUpgradeCta` to true which is when large quantity is selected, do not show the upgrade CTA (checkbox).
  */
  showUpgradeCta: boolean = true;

  /** Hardcoded subscription filter prices by unit count — HEPA 13 (edit as needed). */
  private readonly subscriptionFilterPriceByUnitsHepa13: Record<number, number> = {
    1: 42.00,
    2: 84.00,
    3: 126.00,
  };

  /** Hardcoded subscription filter prices by unit count — HEPA 14 (edit as needed). */
  private readonly subscriptionFilterPriceByUnitsHepa14: Record<number, number> = {
    1: 52.00,
    2: 105.00,
    3: 157.00,
  };
  override iconPaypal: string = 'https://www2.thehealthyfat.com/assets/img/paypalButton.jpg';
  public override twoNameShipping: boolean = true;
  constructor(
    public override navCtrl: NavControllerExt,
    public override sanitizer: DomSanitizer,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public override cart: CartProvider,
    public override tcrApi: TouchcrApiGeneralExtenderProvider,
    public override tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override toastCtrl: ToastController,
    public override eventStreamer: EventStreamerProvider,
    public override tcrApiLead: TouchcrApiLeadProvider,
    public override tcrApiCoupon: TouchcrApiCouponProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentExtenderProvider,
    public override ngZone: NgZone,
    public override shippingProvider: TouchcrApiShippingProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override orderHelper: OrderProvider,
    public override orderHelperExtender: OrderProviderExtender,
    public override stateProvider: StateProvider,
    public override general: GeneralProvider,
    public override funnelProvider: FunnelSettingsProvider,
    public override spinner: SpinnerProvider,
    public override location: PlatformLocation,
    public override loggingProvider: LoggingProvider,
    public override currencyPipe: CurrencyPipe,
    public override router: Router,
    public override dynamicCurrencyPipe: DynamicCurrencyPipe,
    private cdr: ChangeDetectorRef,
    private upgradeOption: UpgradeService,
    public override storage?: Storage
  ) {
    super(
      navCtrl,
      sanitizer,
      tcrApiOrderform,
      cart,
      tcrApi,
      tcrApiOrder,
      tcrApiRemoteServices,
      toastCtrl,
      eventStreamer,
      tcrApiLead,
      tcrApiCoupon,
      orderDetails,
      paypalPayment,
      ngZone,
      shippingProvider,
      calculateHelper,
      urlsHelper,
      orderHelper,
      orderHelperExtender,
      stateProvider,
      general,
      funnelProvider,
      spinner,
      location,
      loggingProvider,
      currencyPipe,
      router,
      dynamicCurrencyPipe,
      storage
    );
  }
  
  //Use this method to set up initial values for template variables
  override populatePageData() {
    let body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-qa','checkout-page');

    this.applyUpgradeViewFromCookie();
    this.applyPostUpgradeFromSession();

    this.gundryLogo = '/assets/img/gundryLogo1.jpg';
    this.headerText = '';
    this.showOnOrderForm = true;
    this.unitsSoldIcon = "https://cdn.gundrymd.com/images/trophy.svg"

    this.setDynamicCustomerServiceInfo();

    if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Germany') {
      this.headerText = `<h2>KUNDENDIENST</h2><p>+1 (800) 852-0477 | MF 7:00–17:00 UHR PST | SS 7:00–16:00 UHR PST</p>`;
    } else if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Mexico') {
      this.headerText = `<h2>Servicio al cliente</h2><p>(800) 611-9075 |M-F 7AM-5PM PST | S-S 7AM-4PM PST</p><p>servicioalcliente@gundrymd.com</p>`;
    } else {
      if(this.braintreeDefaultCountry && this.braintreeDefaultCountry != 'United States' ) {
      this.headerText = '<br><h2>CUSTOMER SERVICE</h2>' +
        `<p>${this.dynamicPhoneNumber }<br>${this.dynamicCustomerServiceHours}</p>`;
      } else {
        this.headerText = '<h2>Agents standing by to help</h2>' +
        `<p>800-852-0477</p>`;
      } 
    }
    this.showOnOrderForm = true;

    this.syncUpgradeCheckboxState();
  }

  /**
   * Browsers restore the prior checkout from the back/forward cache with the upgrade checkbox
   * still checked; resync to unchecked when appropriate.
   */
  @HostListener('window:pageshow', ['$event'])
  onValuePackPageShow(_event: PageTransitionEvent): void {
    this.ngZone.run(() => {
      this.applyUpgradeViewFromCookie();
      this.applyPostUpgradeFromSession();
      this.syncUpgradeCheckboxState();
    });
  }

  /**
   * On the pre-upgrade value-pack offer, the opt-in checkbox must not stay checked. Going back to the previous page should not show a checked state.
   */
  private syncUpgradeCheckboxState(): void {
    if (!this.showUpgradeBox || this.isValuePackUpgradedView || !this.showUpgradeCta) {
      return;
    }
    this.upgradeSelected = false;
    this.cdr.detectChanges();
  }

  /**
   * Maps currentFunnel.product.description to a single object for labels, units, subscription, and price.
   * Use this in the template for hardcoded copy driven by description (e.g. HEPA 13/14, unit count, subscription line price).
   */
  get productSummaryMap(): ProductSummaryMap {
    const desc = this.currentFunnel?.product?.description ?? '';
    const upper = desc.toUpperCase();
    const isHepa14 = upper.includes('HEPA 14');
    const filterLabel = isHepa14 ? 'HEPA 14 Filter' : 'HEPA 13 Filter';
    const filterBadge = isHepa14 ? 'HEPA 14' : 'HEPA 13';
    const unitCount = this.getUnitCountFromDescription(desc);
    const unitLabel = unitCount === 1 ? '1 Unit' : `${unitCount} Units`;
    const hasSubscriptionInDescription = upper.includes('SUBSCRIPTION');
    const priceMap = isHepa14 ? this.subscriptionFilterPriceByUnitsHepa14 : this.subscriptionFilterPriceByUnitsHepa13;
    const subscriptionFilterPrice = priceMap[unitCount] ?? priceMap[1];
    return {
      filterLabel,
      filterBadge,
      unitCount,
      unitLabel,
      hasSubscriptionInDescription,
      subscriptionFilterPrice,
    };
  }


  /** Billing date 90 days from now */
  get billingDate90DaysFromNow(): string {
    const d = new Date();
    d.setDate(d.getDate() + 90);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  }


  /** Getting units count from product description */
  private getUnitCountFromDescription(description: string): number {
    if (!description || typeof description !== 'string') return 1;
    const normalized = description.toUpperCase();
    const match = normalized.match(/(\d+)\s*[-]?\s*UNIT(S)?/);
    if (match) {
      const n = parseInt(match[1], 10);
      return n >= 1 && n <= 99 ? n : 1;
    }
    return 1;
  }

  /**
   * True when this load followed the /fst/ upgrade handoff.
   * Show confirmation, not the checkbox.
   */
  get isValuePackUpgradedView(): boolean {
    return this.showUpgradeBox && this.upgradedViewActive;
  }

  /** Difference between the upgraded quantity and the selected quantity.
   */
  get valuePackAddMoreCount(): number {
    return Math.max(0, this.upgradedQuantity - this.selectedQuantity);
  }

  private applyUpgradeViewFromCookie(): void {
    const s = this.upgradeOption.getStateFromCookie();
    this.upgradedQuantity = s.upgradedQuantity;
    this.uom = s.uom;
    this.upgradeSavings = s.upgradeSavings;
    this.showUpgradeCta = !s.hideUpgradeCta;
    this.selectedQuantity = s.selectedQuantity;
  }

  private applyPostUpgradeFromSession(): void {
    if (!this.upgradeOption.consumePostUpgradeSuccessSessionFlag() || !this.showUpgradeBox) {
      return;
    }
    this.upgradedViewActive = true;
    this.cdr.detectChanges();
  }

  onUpgradeSelectedChange(checked: boolean): void {
    if (!this.showUpgradeBox || !this.showUpgradeCta) {
      return;
    }
    if (checked) {
      const state = this.upgradeOption.getStateFromCookie();
      if (!state.upgradeDestination) {
        this.upgradeSelected = false;
        console.warn(
          '[GH] value pack upgrade: cookie must include fst destination for /fst/… routing',
          UPGRADE_COOKIE_NAME
        );
        return;
      }
      this.upgradeSelected = false;
      this.upgradeOption.startFstUpgradeNavigation(state.upgradeDestination);
      return;
    }
    if (!this.upgradeOption.navigateOnUpgradeUncheck()) {
      this.upgradeSelected = true;
    }
  }
} 